'use client';

import classnames from 'classnames';
import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Heart from '@alltrails/denali/icons/Heart';
import HeartFilled from '@alltrails/denali/icons/HeartFilled';
import styles from './styles/styles.module.scss';

// https://www.figma.com/file/mh7ECfwLfHr8jTIaAYOS80/Trail-Cards-Handoff?type=design&node-id=6-22393&mode=design&t=owxmYpF8bihcHicv-0
type HeartButtonProps = {
  isSelected: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
};

const HeartButton = ({ isSelected, onClick, className }: HeartButtonProps) => {
  const intl = useIntl();

  const title = isSelected ? intl.formatMessage({ defaultMessage: 'Remove from list' }) : intl.formatMessage({ defaultMessage: 'Add to list' });

  return (
    <IconButton
      icon={{ Component: isSelected ? HeartFilled : Heart, color: '--color-brand-onyx' }}
      size="sm"
      aria-label={title}
      className={classnames(styles.container, { [styles.isSelected]: isSelected }, className)}
      onClick={onClick}
      testId={title}
      title={title}
      type="button"
    />
  );
};

export default HeartButton;
